module.exports = __webpack_public_path__ + "static/media/dish_card6.feb57fc4.png";